import { useCallback } from 'react';

import { MedicalInformationType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { Link } from '@dreryk/react-components';

import { MedicalInformationAddEntryModalOpener, MedicalInformationApproveDraftSubmitValues } from '~legacy.patient';

import { medicalInformationTranslationKeys } from '../../../../translations';

import { useVisitMedicalInformationCreateCommand } from './AddMedicalInformationLink.hooks';

export type AvailableMedicalInformationTypes = Extract<
   MedicalInformationType,
   | 'ANTHROPOMETRY'
   | 'RISK_FACTOR'
   | 'HOSPITALIZATION'
   | 'MEDICAL_CONSULTATION'
   | 'REHABILITATION'
   | 'REFERRAL'
   | 'ALLERGY'
   | 'ANALYTICAL_TEST_RESULT'
   | 'TREATMENT'
   | 'OTHER'
>;
const AVAILABLE_MEDICAL_INFORMATION_TYPES: AvailableMedicalInformationTypes[] = [
   'ANTHROPOMETRY',
   'RISK_FACTOR',
   'HOSPITALIZATION',
   'MEDICAL_CONSULTATION',
   'REHABILITATION',
   'REFERRAL',
   'ALLERGY',
   'ANALYTICAL_TEST_RESULT',
   'TREATMENT',
   'OTHER',
];

type AddMedicalInformationLinkProps = {
   readonly icon?: JSX.Element;
   readonly patientId: number;
   readonly visitId: number;
};

export const AddMedicalInformationLink = (props: AddMedicalInformationLinkProps): JSX.Element => {
   const { executeAsync: createVisitMedicalInformation } = useVisitMedicalInformationCreateCommand({
      visitId: props.visitId,
   });

   const handleSuccess = useCallback(
      async (
         medicalInformationId: number,
         medicalInformationType,
         parameters: MedicalInformationApproveDraftSubmitValues
      ) => {
         await createVisitMedicalInformation({
            description: parameters.description!,
            medicalInformationId: medicalInformationId,
            type: medicalInformationType,
         });
      },
      [createVisitMedicalInformation]
   );

   return (
      <MedicalInformationAddEntryModalOpener
         availableMedicalInformationTypes={AVAILABLE_MEDICAL_INFORMATION_TYPES}
         patientId={props.patientId}
         onSuccess={handleSuccess}
      >
         {({ openModal }) => (
            <Link
               testId={'addMedicalInformationLink'}
               onClick={openModal}
               label={medicalInformationTranslationKeys.emptyStatePlaceholder.addExamination}
               icon={props.icon}
            />
         )}
      </MedicalInformationAddEntryModalOpener>
   );
};
